import type { FAIconProps } from './FAIconsProps';

const FAIcon = ({ prefix = 'far', icon, className, faClassName, sharp = false, alt, style, ref }: FAIconProps) => {
	if (!sharp) {
		return (
			<span style={style} className={className} aria-label={alt} title={alt} ref={ref}>
				<i className={`${prefix} fa-${icon} ${faClassName ?? ''}`} />
			</span>
		);
	} else {
		return (
			<span style={style} className={className} aria-label={alt} title={alt} ref={ref}>
				<i className={`fa-sharp ${prefix} fa-${icon} ${faClassName ?? ''}`} />
			</span>
		);
	}
};

export default FAIcon;
